routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.pqrsDetail', {
      url: "pqrs/detalle/{id}",
      template: `<pqrs-detail sh-ctrl="shCtrl"></pqrs-detail>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** ./www/components/pqrs/pqrs-detail/pqrs-detail.config.js
 **/